export default {
	result: {
		err: '订单信息错误。',
		success: '支付成功',
		paymoney: '支付金额: ',
		yuan: ' 元',
		order: {
			describe: '支付信息',
			name: '商户名称：',
			no: '订单号：',
			paytime: '支付时间：'
		},
		detail: {
			describe: '明细信息',
			project: '收费项目：',
			range: '收费区间：',
			money: '金额：',
			remark: '备注信息'
		},
		ticket: {
			describe: '票据信息',
			title: '抬头：',
			type: '票据类型：',
			idtype: '纳税人识别号：',
			email: '邮箱：'
		}
	},
	router: {
		pay: {
			unpaid_fee: '待交费用',
			choose_fee: '选交费用',
			self_service: {
				title: '个人服务',
				pay_situation: '交费情况',
				pay_record: '付款记录'
			}
		},
		confirm: {
			pay_ticket: '交费确认',
			pay_confirm: '待支付'
		},
		anonymous: {
			anonymous_pay: '不记名交费'
		}
	},
	home: {
		homepage: '首页',
		title: '交费大厅',
		welcome_text: '欢迎您'
	},
	unpaid_fee: {
		emptyText: '暂无待交费用',
		loading: '加载中...',
		charge_card: {
			range: '交费区间',
			standard: '收费标准',
			count: '数量',
			receive: '当前应交',
			pay: '本次交费'
		},
		selectAll: '全选',
		sumOfMoney: '合计',
		pay: '去交费',
		cancel_success: '取消原订单成功'
	},
	pay_ticket: {
		ticket_info: '开票信息',
		ticket_tips: '请注意：票据抬头默认为学生姓名。如有疑问，请联系财务处收费票税科（020-84110285）。',
		ticket_detail: '订单明细',
		code: '学号',
		name: '名称',
		name_placeholder: '请输入名称',
		bussiness_code: '证件号码',
		fee_remark: '备注信息',
		ticket_remark: '填写票据备注',
		collapse_ticket_remark: '收起票据备注',
		ticket_notify: '电子票通知',
		email: '邮箱',
		email_placeholder: '请输入邮箱',
		sum: '合计金额：',
		commit: '提交订单',
		pay: '去支付',
		add: '新增',
		reset: '重置',
		cancel: '取消',
		search: '查询',
		person_title: '个人',
		company_title: '机构',
		person: '开具个人票据',
		person_tips: '部分收费项目只能使用个人抬头开票。',
		person_placeholder: '请输入票据抬头',
		organ: '开具企业、机构票据',
		organ_placeholder: '请输入机构关键字查询机构抬头',
		add_tips: '当前未选择任何票据抬头，请先查询并选择机构抬头，或',
		add_ticket: '新增一个机构抬头',
		add_organ: '新增机构抬头',
		select_organ: '选择机构抬头',
		close: '关闭',
		check: '选择',
		emptyText: '暂无数据',
		pre_page: '返 回',
		tips: '请输入机构关键字',
		confirm_add_title: '没有符合条件的机构抬头，是否新增抬头？',
		title_not_sysu: '票据抬头不能为中山大学',
		tax_number_not_sysu: '税号不能为中山大学的税号',
		estate_date: '选择租赁日期',
		estate_date_placeholder: '请选择租赁日期',
		estate_date_needed: '不动产租赁收费需要输入租赁日期！',
		estate_addr_lost: '不动产租赁收费尚未设定地址信息，请联系负责该收费部门的老师！',
		organ_model: {
			view_detail: '查看明细',
			fold_detail: '收起明细',
			name: '名称',
			taxNumber: '税号',
			taxNumber_placeholder: '请输入税号',
			address: '单位地址',
			address_placeholder: '请输入单位地址',
			tele: '电话号码',
			tele_placeholder: '请输入电话号码',
			depositBank: '开户银行',
			depositBank_placeholder: '请输入开户银行',
			bank: '银行账户',
			bank_placeholder: '请输入银行账户',
			name_rule: '请填写机构名称',
			taxNumber_rule: '请填写机构税号'
		},
		open_immediately: '马上开票',
		open_later: '延迟开票'
	},
	pay_confirm: {
		tips: '提示',
		tips_content: '存在一个订单未支付，是否前往支付?',
		cancel_order: '取消订单',
		continue_order: '前往支付',
		pay_finish: '支付已完成',
		pay_fail: '支付失败',
		pay_canceled: '已取消支付',
		pay_change: '支付未完成，更改支付方式',
		pay_error: '支付时遇到问题',
		pay_cancel: '取消支付',
		pay_error_title: '支付出问题',
		pay_error_tips: `请记录以下信息，并联系收费老师处理。`,
		pay_error_tips2: `若未扣钱，可取消订单重新交费。`,
		close: '关闭',
		cancel_repay: '取消订单，重新交费',
		timeout_tip: '订单已过期，请刷新页面后重新提交订单。',
		state: {
			confirm: '确定',
			fresh: '刷新订单'
		}
	},
	qrcode_page: {
		range: '交费区间',
		standard: '标准名称',
		count: '数量',
		pay_money: '交费金额',
		price: '单价',
		pay_money_placeholder: '请输入交费金额',
		fee_remark: '填写收费备注',
		fee_remark_fold: '收起收费备注',
		fee_remark_placeholder: '请输入收费备注'
	},
	pay_situation: {
		all: '全部',
		no_range_year: '无区间年度',
		choose_year: '选择年份',
		cancel_text: '取消',
		confirm_text: '确定',
		emptyText: '没有数据',
		pre_page: '返回上一页',
		loading: '加载中...',
		download: {
			title: '下载票据',
			name: '收费项目',
			money: '交费金额',
			date: '交费日期',
			code: '票据号码',
			download: '下载票据',
			close: '关闭',
			tips: '没有可下载的票据'
		},
		list: {
			name: '收费项目',
			range: '交费区间',
			need_money: '应交',
			later_money: '缓交',
			receive_money: '实交',
			operate: '操作',
			detail: '查看详情',
			download: '下载票据',
			noRange: '无区间年度',
			allRange: '全部'
		}
	},
	pay_situation_detail: {
		sum_need_pay: '当前应交合计',
		sum_already_pay: '已交合计',
		standard: '应交',
		discount: '减免',
		deduction: '抵扣',
		laterVos: '缓交',
		reditVos: '贷款',
		payTikectVos: '已交记录',
		nowMoney: '当前需交',
		close: '关闭'
	},
	pay_record: {
		list: {
			code: '订单编号',
			money: '金额',
			pay_type: '支付方式',
			pay_date: '支付时间',
			operate: '操作',
			detail: '查看详情',
			starttime: '开始日期',
			endtime: '结束日期',
			to: '至',
			search: '查询'
		},
		detail: {
			title: '付款详情',
			pay_info: '支付信息',
			pay_detail: '订单明细',
			code: '订单编号',
			status: '订单状态',
			money: '订单金额',
			create_time: '创建时间',
			pay_type: '支付方式',
			pay_time: '支付时间',
			ticket_title: '票据抬头',
			send_to_email: '发送凭据到邮箱',
			email_title: '邮箱地址',
			email_placeholder: '请填入邮箱地址',
			confirm: '确定',
			cancel: '取消'
		}
	},
	choose_fee: {
		range: '交费区间',
		price: '单价',
		money: '收费金额',
		count: '数量',
		maxMoneyMust: '请输入金额',
		maxMoneyStart: '交费上限：￥',
		maxMoneyEnd: '',
		remark: '备注',
		pay: '去交费',
		sum: '合计金额',
		default_range: '默认区间',
		clear: '无选交费用'
	},
	pay_refund: {
		list: {
			project: '收费项目',
			range: '收费区间',
			money: '退费金额',
			type: '退费方式',
			date: '退费日期',
			state: '退费状态'
		}
	},
	message: {
		// 所有的提示信息
		ticketTitle: '请填写抬头信息',
		selectFee: '请选择应收项目'
	},
	success: {
		logout: {
			message: '您确定要退出登录？',
			title: '退出',
			confirmButtonText: '退出',
			cancelButtonText: '取消',
			successMessage: '成功登出'
		}
	},
	error: {
		network: '服务器君开小差了，请稍后再试。',

		message: '{message}',
		messageCause: '{message}</br>错误原因：{cause}',
		cause: '错误原因：{cause}',
		unknown: '未知错误，错误码：{state}',
		// 400: '400请求错误',
		400: '请求发生错误，请重试。',
		401: '401未授权，请登录',
		403: '403拒绝访问',
		404: '404请求地址出错: {url}',
		408: '408请求超时',
		500: '500服务器内部错误',
		501: '501服务未实现',
		502: '502网关错误',
		503: '503服务不可用',
		504: '504网关超时',
		505: '505HTTP版本不受支持',
		state: {
			6010101: '非法请求',
			6020101: '用户名或密码错误'
		}
	}
}
